import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { RootState } from '../../index';

type TicketPortalState = {
  ticketId: string | null;
};

const initialState: TicketPortalState = {
  ticketId: null,
};

const slice = createSlice({
  name: 'ticketPortal',
  initialState,
  reducers: {
    openTicketPortal(state, action: PayloadAction<{ ticketId: string }>) {
      state.ticketId = action.payload.ticketId;
    },
    closeTicketPortal(state) {
      state.ticketId = null;
    },
  },
});

export const ticketPortalReducer = slice.reducer;
export const { openTicketPortal, closeTicketPortal } = slice.actions;

export const selectOpenTicketPortalId = (state: RootState) => state.ticketPortal.ticketId;
export const selectIsTicketPortalOpen = (state: RootState) => Boolean(state.ticketPortal.ticketId);
